// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.txtitem_title[data-v-1a8cd098] {\n  background: rgb(200, 200, 200);\n}\n.cell--selected[data-v-1a8cd098] {\n  background: rgb(60, 170, 255, 0.3);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
